import { render } from "./ByValue.vue?vue&type=template&id=72fc9640"
import script from "./ByValue.vue?vue&type=script&lang=js"
export * from "./ByValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__